import React from 'react';
import { ShieldCheck, TrendingUp, FileText } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const icons = [ShieldCheck, TrendingUp, FileText];

const Pillars = () => {
  const { t } = useLanguage();

  return (
    <section id="pillars" className="section-bg relative py-28">
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-16">
          <p className="dash-title mb-5">{t.pillars.eyebrow}</p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-[3.25rem] light-text leading-[1.25] max-w-3xl mx-auto pb-3">
            {t.pillars.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {t.pillars.items.map((item, i) => {
            const Icon = icons[i];
            return (
              <div key={i} className="card-bg rounded-lg p-8 lg:p-10">
                <div className="icon-box w-12 h-12 rounded-md flex items-center justify-center mb-8">
                  <Icon className="w-5 h-5" />
                </div>
                <h3 className="font-serif text-2xl lg:text-[1.7rem] gold-text mb-5 leading-snug">
                  {item.title}
                </h3>
                <p className="text-[#9CA3AF] text-sm lg:text-base leading-relaxed font-light">
                  {item.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Pillars;
